import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

// Routes 

import { getReferrals } from '../../../routes/hacker/users';

// Components 

import ReferralRow from './ReferralRow';
import LinearProgress from '@mui/material/LinearProgress';

import ReferralsHeader from './ReferralsHeader';
import Section from '../../general/containers/Section';
import { setInitialRendering, setIsRefreshReferralsList, setReferrals, setSelectedReferral } from '../../../redux/features/hacker/users/referralsAccess';

const ReferralsList: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  

    const isRefreshReferralsList = useAppSelector(state => state.referralsAccess.isRefreshReferralsList);  
    const selectedReferral = useAppSelector(state => state.referralsAccess.selectedReferral);  
    const referrals = useAppSelector(state => state.referralsAccess.referrals);  
    const initialRendering = useAppSelector(state => state.referralsAccess.initialRendering);  

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 

    // -- 

    const getReferralsList = async () => { 

      const res = await getReferrals() as any; 

      if (res.data.status === 200) { 

        dispatch(setReferrals(res.data.referrals)); 

      };

    }; 

    // -- 

    const handleSelection = (e: any, referral: any) => { 

      if (selectedReferral) { 

        if (selectedReferral?._id == referral?._id) { 

          dispatch(setSelectedReferral(null)); 

          return; 
  
        }; 

      }; 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

      dispatch(setSelectedReferral(referral)); 

    }; 

    // -- 

    useEffect(() => { 

      if (initialRendering) { 

          getReferralsList(); 

          dispatch(setInitialRendering(false)); 

      }; 

    },[initialRendering]); 

    // -- 

    useEffect(() => { 

      if (isRefreshReferralsList) { 

        getReferralsList(); 

        dispatch(setIsRefreshReferralsList(false)); 

      }; 

    },[isRefreshReferralsList]); 

    // -- 
    
    return (

        <Section
          extraStyle={{ 
            backgroundColor: colors?.container,
            paddingLeft: '3vw', 
          }}
        >      
            
            <ReferralsHeader />

            { (referrals?.length >= 1) && 
            <Box sx={{ 
                overflow: 'auto',
                width: '100%',
                marginTop: '2vh' }}>
        
                <List dense>
        
                {referrals?.map((referral, index) => (
        
                    <ListItem sx={{ color: colors?.text }} onClick={(e) => handleSelection(e, referral)} button key={index}>

                        <ReferralRow item={referral} /> 
       
                    </ListItem>

                ))}
        
                </List>
        
            </Box>}

            {(referrals?.length === 0) &&         
          
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-evenly', 
              height: '100%',
              width: '80%', 
          }}>

              <Box
                  sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
              }}>

                  <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                  <Box>Retrieving Referrals...</Box>

              </Box>

          </Box>}

        </Section>
    
      );

};

export default ReferralsList;